// extracted by mini-css-extract-plugin
export default {"fieldContainer":"ProductFeature_fieldContainer__o-faS"};